import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CostCenterByLocationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CostCenterByLocationCreateDto,
  CostCenterByLocationDto,
  CostCenterByLocationExcelDownloadDto,
  CostCenterByLocationUpdateDto,
} from '../proxy/planning/dtos/cost-center-by-location';
import { COSTCENTERBYLOCATION_CONFIG, COSTCENTERBYLOCATION_FIELDS } from './cost-center-by-location.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-cost-center-by-location',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CostCenterByLocationService, ConfirmationService],
  templateUrl: './cost-center-by-location.html',
  styleUrl: './cost-center-by-location.scss',
})
export class CostCenterByLocation extends BaseHierarchicalCrudComponent<
  CostCenterByLocationDto,
  CostCenterByLocationCreateDto,
  CostCenterByLocationUpdateDto,
  CostCenterByLocationExcelDownloadDto
> {
  service = inject(CostCenterByLocationService);
  config = COSTCENTERBYLOCATION_CONFIG;
  fields = COSTCENTERBYLOCATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: CostCenterByLocationDto): CostCenterByLocationUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CostCenterByLocation';
  }
}
